import { parse } from 'hub-http/helpers/params';
import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
export const useSetQueryParams = () => {
  const location = useLocation();
  const history = useHistory();
  return useCallback(newParams => {
    const originalParams = parse(location.search.slice(1));
    const newParamsEncoded = Object.entries(newParams).reduce((acc, [key, value]) => {
      if (Array.isArray(value)) {
        acc[key] = value.map(v => encodeURIComponent(v.toString()));
      } else {
        acc[key] = encodeURIComponent(value.toString());
      }
      return acc;
    }, {});
    const mergedValues = Object.assign({}, originalParams, newParamsEncoded);
    const urlParams = Array.from(Object.entries(mergedValues)).reduce((acc, [key, valuesToSet]) => {
      if (valuesToSet) {
        if (Array.isArray(valuesToSet)) {
          if (valuesToSet.length > 0) {
            acc.append(key, valuesToSet.join(','));
          }
        } else {
          acc.append(key, valuesToSet);
        }
      }
      return acc;
    }, new URLSearchParams());
    history.push({
      search: urlParams.toString()
    });
  }, [history, location]);
};